// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2JIz8","content":"LayoutSettings_content__2T61t"};